import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { Filter } from '../../../../models';
import { Cidade } from '../../../cidade';
import { Usuario } from '../../../usuario';

/** Representa o Filter da entidade Representante */
export class RepresentanteFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    situacoes: number[] = [];
    somenteComClientes: boolean;
    modalidadesComerciais: number[] = [];
    dataCadastroInicial: Date;
    dataCadastroFinal: Date;
    idCidade: number;
    cidade: Cidade;
    idsEstados: number[] = [];
    idsAtendentes: number[] = [];
    idsGerentes: number[] = [];
    idsClassificacoesClientes: number[] = [];
    classificacaoNull = false;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro pesquisa
        if (this.filterPsq && this.filterPsq.trim().length > 0) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Situações
        if (this.situacoes?.length > 0) {
            this.situacoes.forEach(situacao => {
                if (situacao > 0) {
                    params = params.append('situacao', situacao.toString());
                }
            });
        }

        // Modalidades Comerciais
        this.modalidadesComerciais?.forEach(modalidadeComercial => {
            if (modalidadeComercial > 0) {
                params = params.append('modalidadeComercial', modalidadeComercial.toString());
            }
        });

        // Somente com clientes
        if (this.somenteComClientes) {
            params = params.append('somenteComClientes', 'true');
        }

        // Data de Cadastro
        if (this.dataCadastroInicial) {
            params = params.append('dataCadastroInicial', toHTTPParam(this.dataCadastroInicial));
        }
        if (this.dataCadastroFinal) {
            params = params.append('dataCadastroFinal', toHTTPParam(this.dataCadastroFinal));
        }

        // Cidade
        if (this.idCidade) {
            params = params.append('idCidade', this.idCidade.toString());
        }
        // Estados
        if (this.idsEstados?.length > 0) {
            this.idsEstados.forEach(idEstado => {
                params = params.append('idEstado', idEstado.toString());
            });
        }
        // Atendentes
        if (this.idsAtendentes?.length > 0) {
            this.idsAtendentes.forEach(idAtendente => {
                params = params.append('idsAtendentes', idAtendente.toString());
            });
        }
        // Gerentes
        if (this.idsGerentes?.length > 0) {
            this.idsGerentes.forEach(idGerente => {
                params = params.append('idsGerentes', idGerente.toString());
            });
        }

        // Classificações de clientes
        this.idsClassificacoesClientes?.forEach(idClassificacaoCliente => {
            if (idClassificacaoCliente > 0) {
                params = params.append('idClassificacaoCliente', idClassificacaoCliente.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoNull) {
            params = params.append('classificacaoNull', 'true');
        }


        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.situacoes = [];
        this.somenteComClientes = null;
        this.modalidadesComerciais = [];
        this.dataCadastroInicial = null;
        this.dataCadastroFinal = null;
        this.idCidade = null;
        this.cidade = null;
        this.idsEstados = [];
        this.idsAtendentes = [];
        this.idsGerentes = [];
        this.idsClassificacoesClientes = [];
        this.classificacaoNull = false;
    }
}
